<template>
	<div class="FWLN">
		<div class="content fw">
			<div class="content_2 c3 lh7">
				<div class="f30">服务理念</div>
				<div class="f20 mb45">SERVICE CONCEPT</div>
				<transition name="el-fade-in-linear">
					<div v-show="show" style="transition: all 1s;-webkit-transition: all 1s;">
					<el-row :gutter="50">
						<template v-for="(item, i) in fw">
							<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
								<div class="item mb50">
									<el-image style="width: 100%; height: 266px;vertical-align: bottom;" :src="item.url"
										:fit="'cover'"></el-image>
									<div class="f5 f28 ptb20 tz vt">{{item.name}}</div>
								</div>
							</el-col>
						</template>
					</el-row>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				fw: [{
						name: '作业无人化',
						url: require('@/assets/About_fw_1.png')
					},
					{
						name: '管理信息化',
						url: require('@/assets/About_fw_2.png')
					},
					{
						name: '数据可视化',
						url: require('@/assets/About_fw_3.png')
					},
					{
						name: '资源标准化',
						url: require('@/assets/About_fw_4.png')
					},
					{
						name: '成本最优化',
						url: require('@/assets/About_fw_5.png')
					},
					{
						name: '质量规范化',
						url: require('@/assets/About_fw_6.png')
					},
				]
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.show = true
			})
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';

	.FWLN {
		@media screen and (max-width: 768px) {
			overflow: hidden;
		}
		padding-bottom: 65px;

		.fw {
			padding-top: 65px;
			font-size: 18px;
			color: #404040;

			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 16px;
				}

				padding-left: 2vw;
				padding-right: 2vw;
				box-sizing: border-box;
			}
		}

		.item {
			cursor: default;
			
			img {
				transition: all 0.3s;
			}

			&:hover {
				img {
					transform: scale(1.05);
				}
			}

			@media screen and (max-width: 768px) {
				margin-bottom: 20px;

				.f28 {
					font-size: 20px;
					padding: 16px 0;
				}
			}
		}
	}
</style>
